"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureFlag = useFeatureFlag;
var _react = require("react");
var _ = require("./");
function useFeatureFlag(flagName) {
  const featureFlags = (0, _react.useContext)(_.FeatureFlagContext).featureFlags || {};
  return featureFlags[flagName] || false;
}